export default {
  innerColor: '',
  locationContainerBackground: 'none',
  styledLinkColor: '',
  titleColor: Styles.color.black,
};
